import LdjsonNewsArticle from "@/shared/Schemas/NewsArticle";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";

export const ServiceLdjsonNewsArticle = () => {

    const dataContext = useContext(TemplateContext);
    const { content: formatContent, ...rest } = dataContext || {};

    const { title = "", section = "" } = rest?.properties?.service;

    const dataNews = {
        publishedDate: formatContent?.publishedDate,
        subtitle: "Todos las predicciones de los signos del zodiaco.",
        title: title,
        summary: formatContent?.summary,
        sections: section,
        lastModified: formatContent?.publishedDate,
        body: formatContent?.body,
        keywords: formatContent?.keywords,
        url: formatContent?.urlCanonical,
        related_image_url:
            "https://www.clarin.com/img/2020/07/07/Fpk73rLHR_1200x630__1.jpg",
    }

    if (section == "horoscopo-chino") {
        dataNews.subtitle = "Todos las predicciones y características del horóscopo chino.";
        dataNews.related_image_url = "https://www.clarin.com/img/2022/10/28/vTOPB6087_1200x630__1.jpg";
    }

    return (
        <LdjsonNewsArticle dataNews={dataNews} />
    );
};